import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 12a9 9 0 1 0 1.204-4.5m0 0V3m0 4.5h4.421"
    />
  </svg>
);
export const IconUndo = withDynamicStroke(Icon);
